import { useLocation } from "react-router-dom";

import { ScrollRestorer as SharedScrollRestorer } from "@epc-front/shared/components/ScrollRestorer";

export const ScrollRestorer = () => {
  const location = useLocation();

  return <SharedScrollRestorer location={location} />;
};
